/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_ANALYTICS = gql`
    query GetAnalytics {
        getAnalytics {
            name
            counts
            choropleth {
                data {
                    _id
                    count
                }
            }
            scansGraph {
                id
                data {
                    x
                    y
                }
            }
            ratingsGraph {
                id
                data {
                    x
                    y
                }
            }
            scansGraphWithBrandProtection {
                id
                data {
                    x
                    y
                }
            }
            sapCallsPerDay {
                _id
                data {
                    _id
                    data {
                        date
                        _id
                        count
                    }
                    status
                }
            }
            provPerProductPerFactory {
                _id
                data {
                    _id
                    data {
                        plantName
                        _id
                        count
                    }
                    name
                }
            }
            updatedAt
        }
    }
`;
